import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import InsertBank from "./insert_bank";
import {TITLES} from './bank_constants'

class AddBank extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: "add_title",
            editData: {},
        };
    }

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.title) {
            this.setState({
                title: this.props.location.state.title,
                editData: { ...this.props.location.state },
            });
        }
    }

    onFormSubmit = () => {
        this.props.history.push("/bank");
        this.props.history.go();
    };
    render() {
        return (
            <React.Fragment>
                <AddTitleBar Title={this.state.editData?.bankId ? TITLES.edit : TITLES.add } LinkName="/bank" />
                <div className="m-2">
                    <InsertBank
                        editData={this.state.editData}
                        onFormSubmit={this.onFormSubmit}
                    />
                </div>
            </React.Fragment>
        );
    }
}
export default AddBank;
